<template>
    <div style="background:white" class="ve-list-page">
        <div style=" background:white;line-height:30px;border-bottom:2px solid #389"> 
            <div style="padding-top:3px;display:flex;width:1400px; ">
                <div style="width:70px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:13px;font-weight:600 ">{{$LANG('0138', '新增')}} </span></el-link>
                </div>
                <el-checkbox border size="small"  @change="selChg"  v-model="v_sel" true-label="Y"  false-label="N"><span style="font-size:12px;color:#389;margin-right:5px">{{$LANG('0140', '全选')}}</span></el-checkbox>
                <span style=" font-size:12px;margin-right:10px;margin-left:10px">{{$LANG('0681', '字段查询')}}</span>
                <el-select v-model="selparam" size="small" :placeholder="$LANG('1675', '请选择列名')" filterable  style="width:150px; " >
                    <span v-for="item in poCol" :key='item.key'>
                        <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N' "></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="$LANG('1692', '请输入查询值')" v-model="txtparam" @keyup.enter.native="stfgChange" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input> 
                <el-button type="danger"   icon="iconfont icon-daochu" @click="nextGen" size="mini" style="margin-left:15px;height:30px;margin-top:1px"> 下推应收单</el-button>
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{$LANG('0683', '字段设置')}}</span></el-link>
            </div>
        </div>   
        <div class="ve-list-page__table">
        <ve-table :columns="vueCol"
            :table-data="outData"
            :column-hidden-option="columnHiddenOption"
            :border-around="true"
            :border-x="true"
            :border-y="true"
            :fixed-header="true"
            row-key-field-name="IDSEQ"
            :row-style-option="rowStyleOption"
            :cell-style-option="cellStyleOption"
            :max-height="subHeight"
            :virtual-scroll-option="virtualScrollOption"
            :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
            :scroll-width="0"
            :column-width-resize-option="columnWidthResizeOption"
            :cellSelectionOption="{enable: false}"
            v-loading="v_loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            id="stk_othout_load"
            ref="refreq">
        </ve-table>
        </div>
        <!-- 分页查询 -->
        <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px" class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <!-- 提示框 -->
        <el-dialog :show-close="false" v-dialogDrag :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">确定</Button>
            </div>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <Form :model="poRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in poCol" :key="index" >
                        <FormItem   :label="item.title"  class="item-width" v-if="item.fhide==='N'" :prop="item.key"  >                  
                            <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="poRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number size="medium" :disabled="saveFlag" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="poRow[item.key]" style="width:100%" ></el-input-number>   
                            <el-select size="medium" filterable :disabled="saveFlag" v-else-if="item.key==='CLNTNO' " v-model="poRow[item.key]"   style="width:100%">
                                <el-row v-for="(item ,index) in clntArr " :key="index">
                                    <el-col :span="9">
                                        <el-option  :label="item.ENAME" :value="item.IDNO"></el-option>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-option  :label="item.CLTYPENM" :value="item.IDNO"></el-option>
                                    </el-col>
                                    <el-col :span="10">
                                        <el-option  :label="item.CLNTNM" :value="item.IDNO"></el-option>
                                    </el-col>
                                </el-row>
                            </el-select>
                            <el-select size="medium" :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="poRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-input size="medium" :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="poRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
                <div class="one-toolbar">
                    <span class="spanRow"> 明细资料</span>
                    <span style="margin-left:10px">
                        <i class="iconfont icon-xinzeng" style="color:white;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                        <el-link :disabled="addBool||saveFlag" @click="addDtl" :underline="false" style="color:white"><span style="font-size:13px;margin-right:15px;">新增明细</span></el-link>   
                    </span>
                </div>
                <el-table  :data="dtlData" 
                    border                            
                    size="small"
                    class="custom-table-border"
                    :row-class-name="tabRowClass"
                    cell-class-name="clearPadding"
                    @row-click="rowClick"
                    v-loading="t_loading"
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                    :height="dtlHeight" 
                    :row-key="getDtlKey"
                    style="margin-top:-8px"
                    show-summary
                    :summary-method="getSummary"
                    ref="refdtl"
                    highlight-current-row > 
                    <el-table-column label="序号" type="index" width="60"></el-table-column>          
                    <el-table-column v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N')" :key="index" 
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.key!=='RN'&&item.sortable=='N'"
                        :min-width="item.width">
                        <template slot-scope="scope">
                            <span v-if ="saveFlag" >
                                <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                <span v-else-if="item.key=='MATTY'" v-text="scope.row['CMATTY']"></span>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                            <span v-else >                    
                                <el-select size="mini" v-if="item.key=='MATTY'" v-model="scope.row[item.key]">
                                    <el-option v-for="(item,index) in tyArr" :label="item.CNAME" :value="item.SUBNO" :key="index"></el-option>
                                </el-select>
                                <el-input readonly  @focus="inputBtn(scope.row,scope.$index,item.key)" :ref="'pos'+scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )" v-else-if="item.edcss=='button'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>  
                                <el-input type="number" @change="qtyPrc(scope.row,scope.$index,item.key )" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue" @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"   v-else-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <el-date-picker :ref="'pos'+scope.$index+item.key" type="date" size="mini" v-else-if="item.edcss==='date'" v-model="scope.row[item.key]" :clearable="false" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>  
                                <el-select v-else-if="item.key==='TAX'" size="mini" v-model="scope.row[item.key]"  style="width:100%" >
                                    <el-option v-for="(item ) in taxArr" :key="item.SUBNO" :label="item.SUBNO" :value="item.SUBNO"></el-option>
                                </el-select>
                                <el-select v-else-if="item.key==='STKNO'" size="mini" v-model="scope.row[item.key]"  style="width:100%" >
                                    <el-option v-for="(item ,index) in stkArr" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                </el-select>
                                <el-input  @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"   v-else-if="item.disabled=='N' " size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <span v-else  v-text="scope.row[item.key]" style="width:100%"> </span> 
                            </span>
                        </template> 
                    </el-table-column>            
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="120">
                        <template slot-scope="scope">
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="saveFlag" @click="dtlDel(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:5px;">删除 </span></el-link>                    
                            <i class="iconfont icon-chakan-copy" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link @click="qryStkLog(scope.row  )" :underline="false"  ><span style="font-size:12px;margin-right:5px;">查库存 </span></el-link> 
                        </template>
                    </el-table-column>  
                </el-table>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">            
                    <i class="web-font" style="font-size:14px;margin-right:20px;color:#ed4014;font-weight:600"> 提示：订单审核后不能再编辑 , 如需编辑请弃审</i> 
                    <span style="margin-right:20px">
                        <i v-if="poRow['STFG']==='N'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-weishenhe3"> </i>
                        <i v-else-if="poRow['STFG']==='Y'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yishenhe1"> </i>
                        <i v-else-if="poRow['STFG']==='X'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yizuofei"> </i>
                    </span>
                    <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button :disabled="addBool||saveFlag"  @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button> 
                </span>
            </div>
        </el-dialog>
 
        <!-- 查看库存 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="logWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">库存日志</span>
            </div> 
            <div style="height:91vh;overflow-y:auto"><stklog v-bind:toolFlag="toolFlag"  v-bind:v_cond="qryCond"></stklog></div>
        </el-dialog>
 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
         <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol"  v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import pubWin from '../datamgt/pubwin.vue'  
 
import stklog from './prd_stklog.vue'
import repWin from '../datamgt/repWin.vue'  
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition, isVeTableMetadataField } from '@/utils/veTableHeaderQuery'
export default {
    name:'stk_othout',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '16035',
            fieldIdseq: '16035',
            fieldLstseq: '1',
            mainColumnKey: 'poCol',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'refreq',
            generatedFixedColumnKeys: ['rownum', 'oper'],
        })
    ],
    data () {
        return {
            sendVal:'PRD',
            comboArr:[],
            toolFlag:false,
            logWin:false,
            qryCond:'',
            taxArr:[],
            v_sel:'N',
            promptWin:false,
            dtlFlag:'create',
            prdRow:{},
            supFlag:'',
            addFlag:'create',
            supRow:{
                SUPNO:'' ,//供应商编码
                SUPNM:'', //供应商名称
                RMK:'', //备注
            },
            rowDtl:{},
            delPrdArr:[],
            stfgSet:'ALL',
            delDtlArr:[],
            prompt:'',
            input_hold:'请输入内容...',
            ruleValidate:{},
 
            selparam:'IDNO',
            txtparam:'',
            v_row:{},
            poRow:{},
            t_loading:false,
            goPage:'',
            rowIdseq:'',
            outData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            cancelBool:false, //作废权限
            v_loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            matData:[],
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            v_url:'xuper_auth/getTableRecMany', 
            pageList: [{
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            dataCount:0,
            rowSize:50,
            dtlCol:[],
            matCol:[],
            poCol:[],
            operArr:[],
            prcCol:[],
            prcData:[],
            prdIndex:'',
            oper:'like',
            colory:'#959997', //审核颜色
            colorx:'#e00e66', //作废颜色
            v_idseq:this.$cookies.get('idseq'),
            dtlIndex:'',
            matWin:false,
            clntArr:[],
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            btnWin:false,
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            repUrl:'',
            repWin:false,
            chkIndex:'',
            tyArr:[],
            prodCol:[],
            v_tabRow:{},
            v_tabIndex:'',
            v_commit :true,
            stkArr:[],
            initCol:[],
            vueCol:[],
            columnHiddenOption: {
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,
            },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            virtualScrollOption: { enable: false },
            queryRequestId:0,
            headerSortKey:'',
            headerSortOrder:'',
        }
    },
    components: {
      pubWin,  //注册组件
      repWin,

      stklog,
      VeColumnConfigDialog,
      // JSX compiles the query header tag to a runtime component lookup.
      // eslint-disable-next-line vue/no-unused-components
      VeTableQueryHeader,
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 162) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 290) + 'px';
        }, 
    },
    mounted () {
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','16035','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });  
        getBaseData(this.v_url,'PARENTNO','16224','','','v_sys_base','').then(res=>{
            this.tyArr =res.result
        }) 
        //客户
        getBaseData(this.v_url,'corpid',this.v_corpid,'','','v_bs_clnt','').then(res=>{
            this.clntArr =res.result
        })
        //税率
        getBaseData(this.v_url,'parentno','249' ,'','','v_sys_base','').then(res=>{
            this.taxArr =res.result
        })
        getBaseData(this.v_url,'parentno','15411' ,'','','v_sys_base','').then(res=>{
            this.stkArr =res.result
        })
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','16035','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16035','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空',trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.getPoList('') //询价单主数据    
            this.comSelect() 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='AMT' ||column.property==='ACTQTY'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        nextGen(){
            const v_len =this.outData.filter(item=>item['SEL']=='Y').length
            if (v_len ==0){
                this.promptWin =true
                this.prompt ='请选择要下推的记录'
            }else{
                this.$confirm( '你确定要下推生成销售应收单吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    
                    let v_idseqArr =this.outData.filter(item=>item['SEL']=='Y').map(item=>Object.assign({IDSEQ:item.IDSEQ}))
                    this.$axios({
                        method: 'post',
                        url: 'xuper_auth/mrp_Calc',
                        data: {p_json:JSON.stringify(v_idseqArr), corpid:this.v_corpid, p_action:'RECEIVE' },
                    }).then(res=>{ 
                        if (res.code=='200'){        
                            this.$notify({
                                title: '成功',
                                message: '已成功下推销售应收单，请到销售应收单界面中查看' ,
                                type: 'success'
                            })
                            this.getStkList('') 
                        }else{
                            this.promptWin =true
                            this.prompt ='下推失败！'+res.result
                        }
                    })
    
                }).catch(err=>{})
            }
        },
        selChg(){
            if (this.v_sel =='Y'){
                this.outData.filter(item=>item.STFG=='Y').filter(item=>!item['ARNO']).forEach((item,index)=>{
                    item['SEL'] ='Y' 
                })
            }else{
                this.outData.filter(item=>item.STFG=='Y').forEach((item,index)=>{
                    item['SEL'] ='N' 
                })
            }            
        },
        qtyPrc(row,index,key){
            if (key=='TAXPRC'|| key=='ACTQTY' ){
                if (row['ACTQTY'] && row['TAXPRC']) 
                //this.dtlData.splice(index,1,{AMT:(Number(row['ACTQTY'])*Number( row['TAXPRC'])).toFixed(2)  })
                row['AMT'] = (Number(row['ACTQTY'])*Number( row['TAXPRC'])).toFixed(2)   
            }
        },
        btnSure(obj){
            if (this.v_key =='MATNO'){
                this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{ MATNO:obj['IDNO'],MATNM:obj['MATNM'],MATDESC:obj['MATDESC'],MATTYNM:obj['MATTYNM'],UNITNM:obj['UNITNM']  } ))
                this.$refs['pos'+ this.v_tabIndex+'ACTQTY'][0].focus()  
                this.chkIndex =this.v_tabIndex
            } 
            this.btnWin =false
        },
        //表格行 按回车键 到下一行
        nextLine(key,val,reftab){ 
            if (val =='enter'){
                if (key =='RMK'){
                    this.chkIndex = this.chkIndex +1
                    let v_count=''
                    if (reftab=='refpos'){
                        v_count =this.dtlData.length
                    }
                    if (this.chkIndex >=v_count) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                }else{
                    if (reftab=='refpos'){
                        let v_col = this.dtlCol.filter(item=>item.thide=='N'&&item.disabled=='N'&&item.edcss!=='checkbox'&&item.edcss!=='select')
                        v_col.some((item,index)=>{
                            if (item.key==key){
                               this.$refs['pos'+this.chkIndex+ v_col[index+1].key][0].focus()  
                            }
                        })
                    }
                }
            }else if (val =='down'){
                this.chkIndex = this.chkIndex +1
                if (reftab=='refpos'){
                    if (this.chkIndex >=this.dtlData.length) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                } 
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                }
            }else if (val =='up'){
                this.chkIndex = this.chkIndex -1
                if (this.chkIndex <=0) {
                    this.chkIndex =0
                }              
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                } 
            }                    
        },
        inputBtn(row,index, key){   
            this.v_key =key         
            if (key=='MATNO'){
                this.v_tabRow =row
                this.v_tabIndex =index
                this.v_table ='v_bs_mat'
                this.tableCol =this.prodCol
                this.v_key2 ='modelno'
                this.v_value2 = row['MATTY']
                this.btnWin =true
            }
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        rowClick(row){
            this.chkIndex =row.index
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt ='请选择报表'
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'16035',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //查看库存
        qryStkLog(row){
            this.logWin=true
            this.qryCond=' and matno=\''+row.MATNO+'\''
        },
 
        //出库明细 
        getDtlList(idseq ){
            this.dtlData=[]
            this.t_loading=true
            getTabColOrData(this.v_url,'v_IC_STKdtl','idseq',idseq,'','','','','' ).then((res) => { 
                this.dtlData =res.result 
                this.t_loading=false
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.refdtl.doLayout()
                }) 
            })            
        },
 
        //明细编辑、删除
        dtlDel(row,index){
            this.delDtlArr.push(row)
            this.dtlData.splice(index,1 )
        },
 
        addDtl(){
            let v_row ={}
            this.dtlCol.forEach(item=>{
                v_row[item.key] =''
            })
            v_row['MATTY']='MAT'
            this.dtlData.push(v_row)
            this.delDtlArr=[]
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            }) 
        },
 
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }   
            }
            this.addFlag='edit'
            this.poRow =JSON.parse(JSON.stringify(Object.assign(row,{IDSEQ:row.IDSEQ})))
            this.rowIdseq=row.IDSEQ
            //出库明细
            this.getDtlList(row.IDSEQ)
            this.addWin=true   
            this.v_commit =true     
        },
        //保存记录
        saveRec(){
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.poRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool &&this.v_commit) { 
                let v_flag=false ,v_qty=false
                this.dtlData.forEach(item=>{
                    if (!item['MATNO']){
                        v_flag =true
                    }
                    if (!item['ACTQTY']){
                        v_qty =true
                    }
                })
                if (this.dtlData.length==0){
                    this.promptWin =true
                    this.prompt ='明细资料不能为空'
                }else if ( v_qty){
                    this.promptWin =true
                    this.prompt ='明细资料中的出库数量不能为空'
                }else if (v_flag){
                    this.promptWin =true
                    this.prompt ='明细资料中的物料编码不能为空'
                }else{
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(this.poRow,{CORPID:this.v_corpid})), p_table:'IC_STK',frmid:'16035'},
                    }).then(res=>{      
                        if(res.result ==='OK')  {  
                            let idseq_ =res.idseq
                            //1、出库明细保存：批量保存   
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.dtlData), p_table:'IC_STKDTL',p_idseq:idseq_ , p_action:'S' },
                            }).then(res=>{
                                if (res.code!=='200'){
                                    this.promtWin=true
                                    this.prompt=res.result
                                }
                            })
                            //出库明细删除
                            for (let k=0;k<this.delDtlArr.length;k++) {
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value: idseq_,p_key2:'lstseq',p_value2:this.delDtlArr[k].LSTSEQ, p_table:'IC_STKdtl'  },
                                })
                            }    
                            this.v_commit =false
                            this.addWin =false   
                            this.getPoList('')
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    }) 
                }
            }
        },
        //新增
        addRec(){
            this.addWin=true
            this.poRow={ICDTTM:getDate('day'),'IDSEQ':'',IDTY:'OTHOUT'}
            this.dtlData=[]
            this.saveFlag=false
            this.v_commit =true
        },
        //表行记录css
        tableRowClass({row, rowIndex}) {
            if (row.STFG  === 'Y') {
                return 'success-row';
            } else if (row.STFG ==='X') {
                return 'cancel-row';
            }
            return '';
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            if (row.IDSEQ && row.LSTSEQ)
            return row.IDSEQ+'-'+row.LSTSEQ
        },
 
        //状态变更
        stfgRec(row,val,index){
            let v_comm='' ,v_cond='', v_chkuser='',v_chkdttm=''
            if (val==='Y'){
                v_comm='审核'
            }else if (val==='N'){
                v_comm='弃审'
            }else if (val==='X'){
                v_comm='删除'
            }
            if (val=='Y'){
                v_chkuser =this.v_usernm
                v_chkdttm=getDate('full')
                v_cond =' set stfg=\''+val+'\' ,chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }else{
                v_cond =' set stfg=\''+val+'\' ,chkuser=null,chkdttm=null'
            }
            this.$confirm('你确定要'+v_comm+'此单据吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'IC_STK',p_cond: v_cond},
                }).then(res=>{      
                    if(res.code =='200')  {  
                        if (val=='X'){
                            this.outData.splice(index,1)
                        }else{         
                            Object.assign(row,{STFGNM:v_comm ,STFG:val,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm})
                        }
                    }else{
                        const errorMsg =res.result
                        const startIndex = errorMsg.indexOf("ORA-20001:") 
                        const endIndex = errorMsg.indexOf("请核查") +3
                        const extractedValue = errorMsg.substring(startIndex, endIndex).trim()
                        if (startIndex>0){
                            this.prompt =extractedValue
                        }else{
                            this.prompt =res.result
                        }
                        this.promptWin =true
                    }        
                })
            }).catch(()=>{})
             
        },
        rowShow(){
            this.v_row ={}
            this.current =1
            this.stfgChange()
        } ,
        sortHeaderColumn(column, edcss){
            const key =column && column.key
            if (!key || !isVeTableMetadataField(this.initCol, key)) return
            if (this.headerSortKey === key) {
                this.headerSortOrder =this.headerSortOrder === 'asc' ? 'desc' : 'asc'
            }else{
                this.headerSortKey =key
                this.headerSortOrder ='asc'
            }
            const direction =this.headerSortOrder === 'asc' ? 1 : -1
            const type =String(edcss || '').toLowerCase()
            this.outData.sort((left, right) => {
                const leftValue =left[key]
                const rightValue =right[key]
                if (leftValue === rightValue) return 0
                if (leftValue === null || leftValue === undefined || leftValue === '') return 1
                if (rightValue === null || rightValue === undefined || rightValue === '') return -1
                if (type === 'number') return (Number(leftValue) - Number(rightValue)) * direction
                if (type === 'date' || type === 'date2' || type === 'time') {
                    return (new Date(leftValue).getTime() - new Date(rightValue).getTime()) * direction
                }
                return String(leftValue).localeCompare(String(rightValue), undefined, { numeric: true }) * direction
            })
        },
 
        //状态查询
        stfgChange(){
            this.headerSortKey =''
            this.headerSortOrder =''
            const toolbarCondition =this.oper === '!=' && isVeTableMetadataField(this.initCol, this.selparam)
                ? ` and ${this.selparam} is null `
                : buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
            const headerCondition =buildVeTableHeaderCondition(this.initCol, this.v_row, {
                typeOverrides: { STFG: 'select' },
                numberOperatorDefault: '>=',
            })
            this.current =1
            this.getPoList(toolbarCondition+headerCondition)
        }, 
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert('请输入跳至页数', '提示', {
                    confirmButtonText: '确定',
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.outData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.outData = this.allList          
            }else{
                
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.outData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            this.$nextTick(() => { //有固定列时 查询后重新布局
                const table = this.$refs.refreq
                if (table && typeof table.doLayout === 'function') table.doLayout()
            }) 
        },
 
        //查询界面
        getPoList(cond){
            const requestId =++this.queryRequestId
            this.v_loading =true
            const orderField =isVeTableMetadataField(this.initCol, this.selparam) ? this.selparam : 'IDNO'
            getTabColOrData(this.v_url,'V_IC_STK_SALERTN','IDTY','OTHOUT','CORPID',this.v_corpid,'','',cond+' order by '+orderField+' desc').then((res) => {
                if (requestId !== this.queryRequestId) return
                this.allList =res.result || []
                this.initPage()
            }).catch(error=>{
                if (requestId !== this.queryRequestId) return
                this.prompt =error.message || this.$LANG('1641', '查询失败')
                this.promptWin =true
            }).finally(()=>{
                if (requestId === this.queryRequestId) this.v_loading=false
            })
        },
 
        //报价商品 
        getMatList(idseq){
            getTabColOrData(this.v_url,'v_IC_STKdtl','idseq',idseq,'','','','','' ).then((res) => { 
                this.matData =res.result 
                if (res.length>0){
                    this.$refs['refmat'].setCurrentRow(res.result[0])
                }else{
                    this.prcData=[]
                }
            })
        },
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16035','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                vm.initCol = res.result
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.poCol = []
                    vm.vueCol = []
                    fieldRows.forEach(itcol => {
                        const title = vm.$translate.getColTitle(itcol, vm.$store.state.lang)
                        vm.poCol.push({
                            title,
                            key: itcol.key,
                            align: itcol.align,
                            width: itcol.width,
                            thide: itcol.THIDE,
                            fhide: itcol.FHIDE,
                            edcss: itcol.EDCSS,
                            disabled: itcol.DISABLED,
                            dotnum: itcol.DOTNUM,
                            sortable: itcol.SORTABLE,
                        })
                        if (String(itcol.THIDE !== undefined ? itcol.THIDE : itcol.thide).toUpperCase() !== 'N') return
                        vm.vueCol.push({
                            field: itcol.key,
                            key: itcol.key,
                            title,
                            align: itcol.align,
                            width: Number(itcol.width) || 120,
                            thide: itcol.THIDE,
                            fhide: itcol.FHIDE,
                            sortable: false,
                            ellipsis: { showTitle: true },
                            renderHeaderCell: ({column}) => <VeTableQueryHeader
                                title={column.title}
                                edcss={itcol.key === 'STFG' ? 'select' : itcol.key === 'SEL' ? 'image' : itcol.EDCSS}
                                value={this.v_row[itcol.key]}
                                operator={this.v_row[`#OPER${itcol.key}`]}
                                defaultOperator=">="
                                showDateOperator={false}
                                sortable={itcol.key !== 'RN' && itcol.key !== 'SEL' && itcol.SORTABLE === 'N' && itcol.EDCSS !== 'checkbox'}
                                sortOrder={this.headerSortKey === itcol.key ? this.headerSortOrder : ''}
                                options={itcol.key === 'STFG' ? [
                                    { value: 'Y', label: this.$LANG('1976', '已审核') },
                                    { value: 'N', label: this.$LANG('2005', '未审核') },
                                ] : (this.comboArr[itcol.key] || [])}
                                on-input={(value) => this.$set(this.v_row, itcol.key, value)}
                                on-operator-change={(value) => this.$set(this.v_row, `#OPER${itcol.key}`, value)}
                                on-title-click={() => this.sortHeaderColumn(column, itcol.EDCSS)}
                                on-query={this.stfgChange}
                            />,
                            renderBodyCell: ({row}) => {
                                const rowVal = row[itcol.key]
                                if (itcol.key === 'IDNO') return <el-link underline={false} on-click={() => this.repBtn(row)}><div style="color:#409eff;border-bottom:1px solid red;font-size:12px">{rowVal}</div></el-link>
                                if (itcol.key === 'STFG' && rowVal === 'Y') return <el-tag size="mini" type="success" effect="dark">{this.$LANG('1976', '已审核')}</el-tag>
                                if (itcol.key === 'STFG' && rowVal === 'N') return <el-tag size="mini" type="info" effect="dark">{this.$LANG('2005', '未审核')}</el-tag>
                                if (itcol.key === 'SEL') return <el-checkbox disabled={!!row.ARNO || row.STFG === 'N'} true-label="Y" false-label="N" v-model={row[itcol.key]} style="width:100%">&nbsp;</el-checkbox>
                                return <span>{rowVal}</span>
                            },
                        })
                    })
                    vm.vueCol.unshift({
                        field: 'index', key: 'rownum', title: vm.$LANG('0310', '序号'), width: 60, align: 'center', fixed: 'left', disableResizing: true,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                        renderHeaderCell: ({column}) => <div class="stk-othout-sequence-header">
                            <div class="stk-othout-sequence-header__title">{column.title}</div>
                            <el-link on-click={vm.rowShow} style="font-size:12px;color:#404eff;height:30px"><el-tooltip content={vm.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link>
                        </div>,
                    })
                    vm.vueCol.push({
                        field: 'oper0', key: 'oper', title: vm.$LANG('0330', '状态操作'), width: 210, align: 'center', fixed: 'right', disableResizing: true,
                        renderBodyCell: ({row, rowIndex}) => <div style="white-space:nowrap">
                            <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                            <el-link on-click={() => this.editRec(row, 'Y', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                            {row.STFG === 'N' ? <span><i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link on-click={() => this.editRec(row, 'N', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('1639', '编辑')}</span></el-link><i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link on-click={() => this.stfgRec(row, 'Y', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0134', '审核')}</span></el-link><i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link on-click={() => this.stfgRec(row, 'X', rowIndex)} underline={false}><span style="font-size:12px">{this.$LANG('0131', '删除')}</span></el-link></span> : null}
                            {row.STFG === 'Y' ? <span><i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link on-click={() => this.stfgRec(row, 'N', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0137', '弃审')}</span></el-link></span> : null}
                        </div>,
                    })
                    vm.applyFieldSettingRows()
                    return res
                })
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16035','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE, 
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prodCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .item-width  {
        width: 32%;
        height:20px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    #stk_othout_load .ve-table-content-wrapper {
        min-height: 100%;
    }
    #stk_othout_load .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight: 700 !important;
        padding: 0 !important;
        padding-top: 4px !important;
        text-align: center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    #stk_othout_load .table-body-cell-class1 {
        font-size: 12px !important;
        color: black !important;
        border-width: 1px !important;
        padding: 2px !important;
        border-color: #808695 !important;
        height: 20px !important;
    }
    #stk_othout_load .stk-othout-sequence-header {
        display: flex;
        flex-direction: column;
        align-items: center;
        line-height: 1;
    }
    #stk_othout_load .stk-othout-sequence-header__title {
        margin-top: 3px;
        white-space: nowrap;
    }
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
